import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TrackingModule} from '@ox/data';
import {TranslateModule} from '@ox/translate';
import {DowngradeModalComponent} from './downgrade-modal.component';
import {ShopServiceModule} from '@webu/data';
import {LoadingModule} from '@ox/ui';
@NgModule({
  declarations: [
    DowngradeModalComponent
  ],
  imports: [
    CommonModule,
    TrackingModule,
    TranslateModule,
    ModalModule.forChild(),
    LoadingModule,
    ShopServiceModule
  ],
  providers: [],
  exports: [
    DowngradeModalComponent
  ]
})
export class DowngradeModalModule {

}
